<div class="flex-auto flex items-center container justify-content-center">
  <div class="text-[16px] md:text-[16px] md:font-medium text-center sm:block subheading-2">
    <span [style.font-family]="'var(--vex-font)'">© Copyright {{this.currentYear}}. All rights reserved.</span>
    <span class="text-info cursor-pointer" (click)="openUrl('https://volmint.com')" [style.font-family]="'var(--vex-font)'">Volmint Technologies</span>
  </div>
</div>
